import React, { Component } from 'react';
import DownloadLinkExpired from '../components/modals/DownloadLinkExpired';

class DownloadFile extends Component {
  constructor(props) {
    super(props);

    this.state = {
        has_file: false,
        file_data: null,
        file_name: '',
        errored: false,
        message: '',
        linkExpiredModalVisible: false
    }
  }

  componentDidMount = () => {
    fetch(window.location.protocol + '//' + window.location.host + '/api/archive/download_document'+this.props.location.search)
        .then(res => res.json())
        .then((result) => {
            if(result.message == "jwt expired")
                this.setState({
                    errored: true,
                    message: result.message,
                    linkExpiredModalVisible: true
                })

            if(result.fileData)
                this.setState({
                    has_file: true,
                    file_data: result.fileData,
                    file_name: result.fileName
                })
        })
        .catch(error => { 
            this.setState({
                errored: true,
                message: error.message,
                linkExpiredModalVisible: true
            })
        });
  }

  componentDidUpdate = (prevProps, prevState) => {
      if(this.state.has_file && this.state.file_data !== prevState.file_data)
        this.fileElement.click();
  }

  toggleLinkExpiredModal = () => {
      this.setState({
          linkExpiredModalVisible: !this.state.linkExpiredModalVisible
      })
  }

  render(){
    let linkExpiredModal = <div />;

    if(this.state.linkExpiredModalVisible)
        linkExpiredModal = <DownloadLinkExpired visible={this.state.linkExpiredModalVisible} toggle={this.toggleLinkExpiredModal} />
    
    return(
        <div>
            {this.state.has_file &&
                <a href={"data:application/pdf;base64,"+this.state.file_data} download={this.state.file_name} ref={a => this.fileElement = a} />
            }
            {linkExpiredModal}
        </div>
    )
  }
}

export default DownloadFile;